/**
 * Reconhece um link do YouTube e extrai o id do vídeo.
 *
 * Espelho de App\Support\Youtube (PHP): o cadastro valida lá, a loja monta o
 * player aqui, e os dois precisam concordar — senão o servidor aceita um link
 * que a loja não toca, ou a loja tenta tocar o que o servidor recusou.
 *
 * Só YouTube: o player é um `<iframe>` para o domínio do YouTube. Qualquer
 * outra URL aqui seria embutir uma página estranha dentro da loja.
 */
const PADROES = [
  /^https?:\/\/(?:www\.|m\.)?youtube\.com\/watch\?(?:[^#]*&)?v=([A-Za-z0-9_-]{11})/,
  /^https?:\/\/(?:www\.|m\.)?youtube\.com\/(?:embed|shorts|live)\/([A-Za-z0-9_-]{11})/,
  /^https?:\/\/youtu\.be\/([A-Za-z0-9_-]{11})/,
];

export function youtubeId(url) {
  const u = String(url || "").trim();
  for (const p of PADROES) {
    const m = u.match(p);
    if (m) return m[1];
  }
  return null;
}

/**
 * URL do player. `youtube-nocookie.com` é o domínio que o próprio YouTube
 * oferece para embutir sem gravar cookie de rastreio antes do play — a loja
 * não precisa entregar o visitante ao anúncio só porque ele abriu a página.
 * `rel=0` limita os vídeos sugeridos no fim ao mesmo canal, em vez de
 * qualquer coisa que o algoritmo ache parecido com "cadeira de rodas".
 */
export function youtubeEmbedUrl(id) {
  return `https://www.youtube-nocookie.com/embed/${id}?rel=0`;
}
